module.exports = __webpack_public_path__ + "media/images/lb/590-248fec4d4090e579727e91c997eb6179.svg";